var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apiClientServices from "../..";
const getUserServiceUrl = () => {
    return "/usr-srvc";
};
const getTenantNameUsingEnv = () => {
    if (process.env.REACT_APP_ENV === "production") {
        return "nuvamawealth";
    }
    else if (process.env.REACT_APP_ENV === "staging") {
        return "nuvamawealth-staging";
    }
    else {
        return "nuvamawealth";
    }
};
function getTenantSettings(tenantName) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield apiClientServices.get(`/usr-srvc/tenant`, {
                params: {
                    tenantName: getTenantNameUsingEnv(),
                },
            });
            if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.result) {
                return {
                    data: (_b = response.data) === null || _b === void 0 ? void 0 : _b.result,
                    status: response.status,
                };
            }
            else {
                throw new Error(`Failed to fetch user profile: ${response}`);
            }
        }
        catch (error) {
            return {
                data: undefined,
                error: error,
            };
        }
    });
}
const tenantService = {
    getTenantSettings,
};
export default tenantService;
